module.exports = __webpack_public_path__ + "img/1.4ad3af6a.png";